
import { useState } from 'react';
import BottomNav from '../../components/base/BottomNav';
import Header from '../../components/base/Header';

export default function Perfil() {
  const [nome, setNome] = useState('Maria Silva');
  const [email, setEmail] = useState('maria.silva@email.com');
  const [curso, setCurso] = useState('Engenharia de Software');
  const [semestre, setSemestre] = useState('5º Semestre');
  const [bio, setBio] = useState('Apaixonada por tecnologia e sustentabilidade. Sempre buscando aprender mais!');

  const badges = [
    { icon: 'ri-star-fill', name: 'Estrela', color: 'text-yellow-500' },
    { icon: 'ri-fire-fill', name: 'Em Chamas', color: 'text-orange-500' },
    { icon: 'ri-trophy-fill', name: 'Campeão', color: 'text-purple-500' },
    { icon: 'ri-leaf-fill', name: 'Eco Warrior', color: 'text-green-500' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 pb-20">
      <Header title="Meu Perfil" />

      <div className="pt-16 px-6">
        {/* Profile Header */}
        <div className="bg-white rounded-3xl shadow-lg p-6 mt-4">
          <div className="flex flex-col items-center">
            <div className="w-24 h-24 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white text-3xl font-bold mb-4">
              MS
            </div>
            <h2 className="text-2xl font-bold text-gray-800">{nome}</h2>
            <p className="text-gray-600 text-sm mt-1">{email}</p>
            <div className="flex gap-2 mt-3">
              <span className="px-4 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-semibold">
                {curso}
              </span>
              <span className="px-4 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-semibold">
                {semestre}
              </span>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-gray-200">
            <div className="text-center">
              <div className="text-2xl font-bold text-purple-600">1,250</div>
              <div className="text-xs text-gray-600 mt-1">Pontos</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-blue-600">48</div>
              <div className="text-xs text-gray-600 mt-1">Mentorias</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">12</div>
              <div className="text-xs text-gray-600 mt-1">Badges</div>
            </div>
          </div>
        </div>

        {/* Badges */}
        <div className="mt-6">
          <h3 className="text-lg font-bold text-gray-800 mb-3">Minhas Conquistas</h3>
          <div className="grid grid-cols-4 gap-3">
            {badges.map((badge, index) => (
              <div key={index} className="bg-white rounded-2xl p-4 shadow-md text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto">
                  <i className={`${badge.icon} text-3xl ${badge.color}`} />
                </div>
                <p className="text-xs text-gray-600 mt-2">{badge.name}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bio */}
        <div className="mt-6 bg-white rounded-2xl shadow-md p-5">
          <h3 className="text-lg font-bold text-gray-800 mb-3">Sobre Mim</h3>
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-purple-500"
            rows={4}
            maxLength={500}
          />
        </div>

        {/* Edit Form */}
        <div className="mt-6 bg-white rounded-2xl shadow-md p-5">
          <h3 className="text-lg font-bold text-gray-800 mb-4">Editar Informações</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Nome</label>
              <input
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Curso</label>
              <input
                type="text"
                value={curso}
                onChange={(e) => setCurso(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Semestre</label>
              <input
                type="text"
                value={semestre}
                onChange={(e) => setSemestre(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>
            <button className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white py-3 rounded-full font-semibold cursor-pointer whitespace-nowrap">
              Salvar Alterações
            </button>
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
